import type { ButtonHTMLAttributes, ReactNode } from 'react'
import './przycisk.css'

type Wariant = 'glowny' | 'drugi' | 'cichy' | 'niebezpieczny'
type Rozmiar = 'zwykly' | 'maly'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  wariant?: Wariant
  rozmiar?: Rozmiar
  pracuje?: boolean
  children?: ReactNode
}

export function Przycisk({
  wariant = 'drugi',
  rozmiar = 'zwykly',
  pracuje = false,
  disabled,
  className,
  children,
  ...reszta
}: Props) {
  const klasy = [
    'przycisk',
    `przycisk--${wariant}`,
    rozmiar === 'maly' ? 'przycisk--maly' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <button
      type="button"
      className={klasy}
      disabled={disabled === true || pracuje}
      aria-busy={pracuje || undefined}
      {...reszta}
    >
      {children}
    </button>
  )
}
